import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ "source" ]
  
  copy(event) {
    event.preventDefault();
    this.sourceTarget.select()
    document.execCommand("copy")
    this.triggerFeedback();
  }
  
  triggerFeedback() {
    const link = this.element.querySelector('a')
    const originalLinkText = link.innerHTML
    link.innerHTML = 'copied!'
    setTimeout(function() {
      link.innerHTML = originalLinkText
    }, 2000)
  }
}